import { Stack } from 'expo-router';
import { withUnistyles } from 'react-native-unistyles';

export const unstable_settings = {
  initialRouteName: 'index',
};

const UnistylesStack = withUnistyles(Stack, (theme) => ({
  screenOptions: {
    contentStyle: {
      backgroundColor: theme.colors.background,
    },
    headerStyle: {
      backgroundColor: theme.colors.background,
    },
    headerShadowVisible: false,
    headerTintColor: theme.colors.typography,
    headerTitle: '',
  },
}));

export default function AuthSignInLayoutRoute() {
  return <UnistylesStack />;
}
